import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { useFormState } from 'react-final-form';
import fetchInsurancePlanOptions from 'src/components/Insurance/utils/fetchInsurancePlanOptions';
import { isHttpError } from 'common/utils/Error';
import PaymentsInsuranceFields from './PaymentsInsuranceFields';
import generatePlanOptionsErrors from './utils/generatePlanOptionsErrors';

class PaymentsInsuranceFieldsContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      insurancePlanOptions: [],
      requiredFields: false,
    };

    this.fetchAndSetPlanOptions = this.fetchAndSetPlanOptions.bind(this);
    this.onChangeType = this.onChangeType.bind(this);
    this.setRequiredFields = this.setRequiredFields.bind(this);
    this.searchInsurancePlanOptions = this.searchInsurancePlanOptions.bind(this);
  }

  componentDidMount() {
    const { currentValues } = this.props;
    const planType = currentValues?.plan_type;

    if (planType) {
      this.fetchAndSetPlanOptions({ planType });
    }
  }

  componentDidUpdate(prevProps) {
    const { currentValues } = this.props;
    const prevValues = prevProps.currentValues || {};
    const values = currentValues || {};

    /* If there are any changes made in the insurance form */
    if (prevValues.member_id !== values.member_id ||
      prevValues.enrollment !== values.enrollment ||
      prevValues.expiration !== values.expiration ||
      prevValues.group_id !== values.group_id ||
      prevValues.plan_type !== values.plan_type ||
      prevValues.plan !== values.plan) {
      this.setRequiredFields();
    }

    if (prevValues.plan_type !== values.plan_type && values.plan_type) {
      this.fetchAndSetPlanOptions({ planType: values.plan_type });
    }
  }

  onChangeType(planType) {
    this.clearInsuranceDetails();

    if (planType) {
      this.fetchAndSetPlanOptions({ planType });
    }
  }

  setRequiredFields() {
    const { currentValues } = this.props;
    const values = currentValues || {};

    /*  If values in insurance form are empty then display asterisk */
    if (values.expiration === '' &&
      values.enrollment === '' &&
      values.group_id === '' &&
      values.member_id === '' &&
      values.plan_type === '' &&
      values.plan === '') {
      this.setState({ requiredFields: false });
    } else {
      this.setState({ requiredFields: true });
    }
  }

  fetchAndSetPlanOptions({ planType, planName }) {
    if (!planType) return;

    const { contactId } = this.props;

    fetchInsurancePlanOptions({ planType, planName })
      .then((response) => this.setState({ insurancePlanOptions: response.data.data }))
      .catch((response) => {
        if (isHttpError(response)) {
          generatePlanOptionsErrors({ response, contactId });
        }
        this.setState({ insurancePlanOptions: [] });
      });
  }

  clearInsuranceDetails() {
    const { fieldPrefix, form } = this.props;

    this.setState({ insurancePlanOptions: [] });

    /* PlanType is filter for Payments Form. Triggering PlanType clears all fields except plan_type & id */
    const fieldsToClear = ['plan', 'member_id', 'group_id', 'enrollment', 'expiration'];
    fieldsToClear.forEach((fieldName) => {
      form.change(`${fieldPrefix}.${fieldName}`, undefined);
      form.resetFieldState(`${fieldPrefix}.${fieldName}`);
    });
  }

  searchInsurancePlanOptions(search) {
    const { currentValues } = this.props;
    const planType = currentValues?.plan_type;

    this.fetchAndSetPlanOptions({ planType, planName: search });
  }

  render() {
    const {
      fieldPrefix, index, initialValues,
    } = this.props;

    return (
      <div className="payments-insurance__information">
        <PaymentsInsuranceFields
          fieldPrefix={fieldPrefix}
          form={this.props.form}
          index={index}
          insurancePlanOptions={this.state.insurancePlanOptions}
          onChangeType={this.onChangeType}
          requiredFields={this.state.requiredFields}
          searchInsurancePlanOptions={this.searchInsurancePlanOptions}
          initialPlanType={initialValues?.plan_type}
          initialPlan={initialValues?.plan}
        />
      </div>
    );
  }
}

PaymentsInsuranceFieldsContainer.propTypes = {
  contactId: PropTypes.string,
  fieldPrefix: PropTypes.string.isRequired,
  form: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  currentValues: PropTypes.object,
  initialValues: PropTypes.object,
};

PaymentsInsuranceFieldsContainer.defaultProps = {
  contactId: '',
  currentValues: {},
  initialValues: {},
};

// Wrapper component to access form state
const PaymentsInsuranceFieldsContainerWrapper = (props) => {
  const { values, initialValues } = useFormState({ subscription: { values: true, initialValues: true } });

  // Get the current values for this specific insurance entry
  const { index } = props;
  const currentValues = values?.insurance?.[index] || {};
  const initialInsuranceValues = initialValues?.insurance?.[index] || {};

  return (
    <PaymentsInsuranceFieldsContainer
      {...props}
      currentValues={currentValues}
      initialValues={initialInsuranceValues}
    />
  );
};

PaymentsInsuranceFieldsContainerWrapper.propTypes = {
  fieldPrefix: PropTypes.string.isRequired,
  contactId: PropTypes.string,
  form: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

PaymentsInsuranceFieldsContainerWrapper.defaultProps = {
  contactId: '',
};

export default PaymentsInsuranceFieldsContainerWrapper;
